import React, { ChangeEvent, useEffect, useState, useRef, useCallback } from 'react'

import { Card } from 'components'
import { useLoading, useModal, useToggle } from 'hooks'
import moment, { Moment } from 'moment'
import { useHistory, useLocation } from 'react-router-dom'
import {
  DateTime,
  IReportsBlock,
  reportsDatabase
} from 'services/database/reportsDatabase'
import {
  MotivosBloqueioInterface,
  MotivoBloqueioServices
} from 'services/NGT/RecordsSheet'
import {
  IFillCardsResponse,
  ReportsBlockServices
} from 'services/NGT/ReportsBlock'
import { UserCsnService } from 'services/Supplier/Users'
import { COLORS, SPACING } from 'utils'

import { TypeDate, CardFiltersGrid, ButtonsRow } from './components'
import DirectorsManagers, {
  IDirectorsManagers
} from './components/DirectorsManagers'
import { IOnChangeUnidadeGestora } from 'components/UnidadeGestoraFields'
import { string } from 'yup'

export type ListTypes =
  | 'centros'
  | 'fornecedor'
  | 'contratos'
  | 'empresas'
  | 'fornecedores'
  | 'subFornecedores'


interface IFillCard {
  id: number
  name: string
  checked?: boolean
  cdDocto?: string
}

interface ICheckListsAll {
  centros: boolean
  contratos: boolean
  empresas: boolean
  fornecedores: boolean
  subFornecedores: boolean
}

interface ICheckLists {
  centros: IFillCard[]
  contratos: IFillCard[]
  empresas: IFillCard[]
  fornecedores: IFillCard[]
  subFornecedores: IFillCard[]
}

export interface IInputFields {
  fornecedorIds?: number[];
  contratoIds?: number[];
  empresaIds?: number[];
  empresaSubContratadaIds?: number[];
  centroPlantaIds?: number[];
  periodoBloqueioInicio?: string;
  periodoBloqueioFim?: string;
  analistaId: number;
  cdCentroPlanta: string;
  cdContrato: string;
  motivoBloqueioId: number;
  nomeEmpresa: string;
  nomeFornecedor: string;
  txDocumento?: string;
  cdFolhaRegistroSRV?: string;
  txReferencia?: string;
  nomeSubcontratada: string;
  tipo: number;
  tipoSolicitacao?: number;
  unidadeGestoraId: number;
  checkedAll: boolean;
}

const persistState = (key: string, value: any) => {
  localStorage.setItem(key, JSON.stringify(value));
};
// Função para recuperar o estado do Local Storage
const getPersistedState = (key, defaultValue) => {
  const storedValue = localStorage.getItem(key);
  return storedValue ? JSON.parse(storedValue) : defaultValue;
};

const ReportsBlock: React.FC = () => {
  const { push, listen: historyListen } = useHistory()
  const { setLoading } = useLoading()
  const { showModal } = useModal()
  const [fornecedor, setFornecedor] = useState<string>('')
  const location = useLocation<any>(); // Usa o hook useLocation
  const state = location.state || {};
  const [subcontratada, setSubcontratada] = useState<string>('')
  const [centro, setCentro] = useState<string>('')
  const [contrato, setContrato] = useState<string>('')
  const [nomeEmpresa, setNomeEmpresa] = useState<string>('')
  const [selectedAnalista, setSelectedAnalista] = useState<string>('')
  const [selectedMatricula, setSelectedMatricula] = useState<string>('')
  const [analistaId, setAnalistaId] = useState<number>(0)
  const [unidadeGestoraID, setUnidadeGestoraID] =
    useState<IOnChangeUnidadeGestora>({} as IOnChangeUnidadeGestora)
  const [listMotivosBloqueio, setListMotivosBloqueio] = useState<
    MotivosBloqueioInterface[]
  >([])
  const [motivoBloqueioId, setMotivoBloqueioId] = useState<number>(0)
  const [tipoRelatorio, setTipoRelatorio] = useState<number>(0)
  const [tipoAcao, setTipoAcao] = useState<number | undefined>()
  const [listMotivosBloqueioFiltrado, setListMotivosBloqueioFiltrado] = useState<MotivosBloqueioInterface[]>([])
  const [cdFolhaRegistroSRV, setCdFolhaRestroSRV] = useState<string>()
  const [txDocumento, setTxDocumento] = useState<string>()
  const [txReferencia, setTxReferencia] = useState<string>()
  const [checkAllRequest, setCheckAllRequest] = useState(false);
  const [isCheckedAllFornecedor, setIsCheckAllFornecedor] = useState(false);
  const [checkSelecionado, setCheckSelecionado] = useState(state?.checkSelecionado || getPersistedState('checkSelecionado', false));
  const [checkValuesInput, setCheckValuesInput] = useState<Boolean>(false)

  const handleCheckAllChange = (checked: boolean) => {
    setIsCheckAllFornecedor(checked);
  };

  const handleCheckSelecionado = useCallback((checked: boolean) => {
    setCheckSelecionado(checked);
    persistState('checkSelecionado', checked);
  }, []);

  const handleChangeInput = (value: string, t: ListTypes) => {
    const listSets = {
      centros: (value: string) => {
        setCentro(value);
        setFields(prevFields => ({ ...prevFields, cdCentroPlanta: value }));
      },
      contratos: (value: string) => {
        setContrato(value);
        setFields(prevFields => ({ ...prevFields, cdContrato: value }));
      },
      empresas: (value: string) => {
        setNomeEmpresa(value);
        setFields(prevFields => ({ ...prevFields, nomeEmpresa: value }));
      },
      fornecedor: (value: string) => {
        setFornecedor(value);
        setFields(prevFields => ({ ...prevFields, nomeFornecedor: value }));
      },
      subFornecedores: (value: string) => {
        setSubcontratada(value);
        setFields(prevFields => ({ ...prevFields, nomeSubcontratada: value }));
      }
    };
    listSets[t](value);
    setCheckValuesInput(
      fields.centroPlantaIds.length > 0 ||
      fields.contratoIds.length > 0 ||
      fields.empresaIds.length > 0 ||
      fields.empresaSubContratadaIds.length > 0 ||
      fields.fornecedorIds.length > 0 ||
      (fields.periodoBloqueioInicio !== null) ||
      fields.periodoBloqueioFim !== null ||
      fields.analistaId !== 0 ||
      fields.cdCentroPlanta !== '' ||
      fields.cdContrato !== '' ||
      fields.motivoBloqueioId !== 0 ||
      fields.nomeEmpresa !== '' ||
      fields.nomeFornecedor !== '' ||
      fields.txDocumento !== '' ||
      fields.cdFolhaRegistroSRV !== '' ||
      fields.txReferencia !== '' ||
      fields.nomeSubcontratada !== '' ||
      fields.tipo !== 0 ||
      fields.tipoSolicitacao !== undefined ||
      fields.checkedAll !== false
    );
  }

  const historyListenerRef = useRef<() => void | null>(null)
  const REPORTS_PATHS = [
    '/ngt/relatorio-fornecedor-bloqueado',
    '/ngt/relatorios-bloqueio',
    '/ngt/relatorio-fr-bloqueada',
    '/ngt/relatorio-fr-liberada',
    '/ngt/relatorio-todos-fornecedores'
  ]

  const unidadeGestoraRef = useRef(null)

  const [fornecedorList, setFornecedorList] = useState<
    { id: number; name: string; flChecked?: boolean; cdDocto?: string }[]
  >([])
  const [contratoList, setContratoList] = useState<
    { id: number; name: string; flChecked?: boolean }[]
  >([])
  const [subFornecedoresList, setSubFornecedoresList] = useState<
    { id: number; name: string; flChecked?: boolean }[]
  >([])
  const [empresaList, setEmpresaList] = useState<
    { id: number; name: string; flChecked?: boolean }[]
  >([])
  const [centroList, setCentroList] = useState<
    { id: number; name: string; flChecked?: boolean }[]
  >([])

  const [analistasList, setAnalistasList] = useState<
    { label: string; value: number }[]
  >([])
  const [matriculasList, setMatriculasList] = useState<
    { label: string; value: number }[]
  >([])
  const [fornecedorIds, setFornecedorIds] = useState<number[]>([])
  const [contratoIds, setContratoIds] = useState<number[]>([])
  const [empresaSubContratadaIds, setEmpresaSubContratadaIds] = useState<
    number[]
  >([])
  const [empresaIds, setEmpresaIds] = useState<number[]>([])
  const [centroPlantaIds, setCentroPlantaIds] = useState<number[]>([])

  const [periodoValidadeIni, setPeriodoValidadeIni] = useState<Date | Moment>(
    null
  )
  const [periodoValidadeFim, setPeriodoValidadeFim] = useState<Date | Moment>(
    null
  )

  const [ignoreGridName, setIgnoreGridName] = useState<
    'contrato' | 'fornecedor' | 'empresa' | 'centro' | 'subFornecedores' | null
  >(null)
  const [refresh, setRefresh] = useState<boolean>(false)
  const [firstMount, toggleFirstMount] = useToggle(true)
  const isInitiaMount = useRef<boolean>(true)

  const DEFAULT_FIELDS: IInputFields = {
    fornecedorIds: [],
    contratoIds: [],
    empresaIds: [],
    empresaSubContratadaIds: [],
    centroPlantaIds: [],
    periodoBloqueioInicio: '',
    periodoBloqueioFim: '',
    analistaId: 0,
    cdCentroPlanta: '',
    cdContrato: '',
    motivoBloqueioId: 0,
    nomeEmpresa: '',
    nomeFornecedor: '',
    txDocumento: '',
    cdFolhaRegistroSRV: '',
    txReferencia: '',
    nomeSubcontratada: '',
    tipo: 0,
    tipoSolicitacao: undefined,
    unidadeGestoraId: 0,
    checkedAll: false
  }

  const [fields, setFields] = useState<IInputFields>(DEFAULT_FIELDS)

  const [checkLists, setCheckLists] = useState<ICheckLists>({
    centros: [],
    contratos: [],
    empresas: [],
    fornecedores: [],
    subFornecedores: []
  })

  useEffect(() => {
    const isFieldsEmpty = (fields): boolean => {
      return Object.values(fields).every(
        (value) =>
          value === '' ||
          value === null ||
          value === 'false' ||
          value === 'null' ||
          value === 'true' ||
          value == 0 ||
          value == undefined ||
          (Array.isArray(value) && value.length === 0)
      );
    };

    if (isFieldsEmpty(fields)) {
      setCheckValuesInput(false);
    } else {
      setCheckValuesInput(true);
    }
  }, [fields, checkLists]);

  useEffect(() => {
    setLoading('loading')
    reportsDatabase.block
      .where({ id: 1 })
      .first()
      .then((block) => {
        setLoading('loading')
        if (block) {
          setCheckLists({
            centros: block.centros.map((centro) => ({
              checked: centro.checked || false,
              id: centro.key,
              name: centro.value
            })),
            contratos: block.contratos.map((contrato) => ({
              checked: contrato.checked || false,
              id: contrato.key,
              name: contrato.value
            })),
            empresas: block.empresas.map((empresa) => ({
              checked: empresa.checked || false,
              id: empresa.key,
              name: empresa.value
            })),
            fornecedores: block.fornecedores.map((fornecedor) => ({
              checked: fornecedor.checked || false,
              id: fornecedor.key,
              name: fornecedor.value,
              cdDocto: fornecedor.cdDocto
            })),
            subFornecedores: block.subfornecedores.map((subfornecedores) => ({
              checked: subfornecedores.checked || false,
              id: subfornecedores.key,
              name: subfornecedores.value
            }))
          })
          setPeriodoValidadeIni(
            moment(block?.inicioBloqueio).isValid()
              ? moment(block?.inicioBloqueio)
              : null
          )
          setPeriodoValidadeFim(
            moment(block?.fimBloqueio).isValid()
              ? moment(block?.fimBloqueio)
              : null
          )

          setFornecedor(block.fornecedor)
          setSubcontratada(block.subcontratada)
          setCentro(block.centro)
          setNomeEmpresa(block.nomeEmpresa)

          setContratoList(
            block.contratos.map((contrato) => ({
              flChecked: contrato.checked || false,
              id: contrato.key,
              name: contrato.value
            }))
          )
          setFornecedorList(
            block.fornecedores.map((fornecedor) => ({
              flChecked: fornecedor.checked || false,
              id: fornecedor.key,
              name: fornecedor.value,
              cdDocto: fornecedor.cdDocto
            }))
          )
          setEmpresaList(
            block.empresas.map((empresa) => ({
              flChecked: empresa.checked || false,
              id: empresa.key,
              name: empresa.value
            }))
          )
          setCentroList(
            block.centros.map((centro) => ({
              flChecked: centro.checked || false,
              id: centro.key,
              name: centro.value
            }))
          )
          setSubFornecedoresList(
            block.subfornecedores.map((subfornecedor) => ({
              flChecked: subfornecedor.checked || false,
              id: subfornecedor.key,
              name: subfornecedor.value
            }))
          )

          setContratoIds(
            block.contratos
              .filter((value) => value.checked)
              .map((value) => value.key)
          )

          setFornecedorIds(
            block.fornecedores
              .filter((value) => value.checked)
              .map((value) => value.key)
          )

          setEmpresaSubContratadaIds(
            block.subfornecedores
              .filter((value) => value.checked)
              .map((value) => value.key)
          )
          setEmpresaIds(
            block.empresas
              .filter((value) => value.checked)
              .map((value) => value.key)
          )

          setCentroPlantaIds(
            block.centros
              .filter((value) => value.checked)
              .map((value) => value.key)
          )

          setTipoRelatorio(block.tipoBloqueio)

          setAnalistaId(block.analistaId)
          setSelectedMatricula(block.matricula || '')
          setSelectedAnalista(block.nmAnalista || '')
          setContrato(block.contrato)
          setMotivoBloqueioId(block.motivo)
          setListMotivosBloqueioFiltrado(block.motivoBloqueioList)
          setCdFolhaRestroSRV(block.cdFolhaRegistroSRV)
          setTxReferencia(block.txReferencia)
          setTxDocumento(block.txDocumento)
          getMotivosBloqueio(block.motivoBloqueioList)
        }
        else {
          getMotivosBloqueio()
        }
      })
      .finally(() => ((isInitiaMount.current = false), setLoading('idle')))
  }, [])

  useEffect(() => {
    if (state?.checkSelecionado !== undefined) {
      handleCheckSelecionado(state.checkSelecionado);
    }
  }, [state]);

  useEffect(() => {
    historyListenerRef.current = historyListen((location) => {
      if (!REPORTS_PATHS.includes(location.pathname)) {
        reportsDatabase.block.delete(1)
        historyListenerRef?.current()
      }
    })
  }, [])

  useEffect(() => {
    !firstMount && !isInitiaMount.current && getFillCards()
    firstMount && isInitiaMount.current && toggleFirstMount()
  }, [refresh, tipoAcao, analistaId, unidadeGestoraID, tipoRelatorio])

  useEffect(() => {
    if (
      moment(periodoValidadeIni).isValid() &&
      moment(periodoValidadeFim).isValid()
    ) {
      !firstMount && !isInitiaMount.current && getFillCards()
      firstMount && isInitiaMount.current && toggleFirstMount()
    }
  }, [periodoValidadeIni, periodoValidadeFim])

  const refreshGrid = (): void => {
    setRefresh((prevState) => !prevState)
  }

  const handleMotivosBloqueioFiltrado = (motivoList = []) => {
    motivoList = motivoList.filter(item => item !== null)
    if (motivoList.length > 0) {
      const filteredlistMotivoBloqueioContratos = motivoList.map((item) => {
        return listMotivosBloqueio?.find((x) => x.txDescricao === item);
      });
      setListMotivosBloqueioFiltrado(filteredlistMotivoBloqueioContratos)
    } else {
      setListMotivosBloqueioFiltrado(listMotivosBloqueio)
    }
  }

  const getMotivosBloqueio = (databseMotivos?: MotivosBloqueioInterface[]) => {

    MotivoBloqueioServices()
      .GetALL()
      .then(({ data }) => {
        setListMotivosBloqueio(data)
        if (databseMotivos == null || databseMotivos.length === 0) {
          if (listMotivosBloqueioFiltrado.length > 0) setListMotivosBloqueioFiltrado(data);
        }
      })
  }

  const ActionCheckbox = (
    actionType: 'add' | 'remove' | 'checkAll' | 'unCheckAll',
    grid: 'contrato' | 'fornecedor' | 'empresa' | 'centro' | 'subFornecedores',
    id?: number
  ) => {
    if (actionType === 'checkAll' && grid === 'fornecedor') {
      setCheckAllRequest(true);
    }




    return {
      add: {
        centro: () => setCentroPlantaIds((prevState) => [...prevState, id]),
        contrato: () => setContratoIds((prevState) => [...prevState, id]),
        empresa: () => setEmpresaIds((prevState) => [...prevState, id]),
        fornecedor: () => setFornecedorIds((prevState) => [...prevState, id]),
        subFornecedores: () =>
          setEmpresaSubContratadaIds((prevState) => [...prevState, id])
      },
      checkAll: {
        centro: () => {
          setCentroList((prevState) =>
            prevState?.map((centro) => ({ ...centro, flChecked: true }))
          )
          setCentroPlantaIds(centroList.map((centro) => centro.id))
          setIgnoreGridName('centro')
          refreshGrid()
        },
        contrato: () => {
          setContratoList((prevState) =>
            prevState?.map((contrato) => ({ ...contrato, flChecked: true }))
          )
          setContratoIds(contratoList.map((contrato) => contrato.id))
          setIgnoreGridName('contrato')
          refreshGrid()
        },
        empresa: () => {
          setEmpresaList((prevState) =>
            prevState?.map((empresa) => ({ ...empresa, flChecked: true }))
          )
          setEmpresaIds(empresaList.map((empresa) => empresa.id))
          setIgnoreGridName('empresa')
          refreshGrid()
        },
        fornecedor: () => {
          setFornecedorList((prevState) =>
            prevState?.map((fornecedor) => ({ ...fornecedor, flChecked: true }))
          )
          setFornecedorIds(fornecedorList.map((fornecedor) => fornecedor.id))
          setIgnoreGridName('fornecedor')
          refreshGrid()
        },
        subFornecedores: () => {
          setSubFornecedoresList((prevState) =>
            prevState?.map((subfornecedor) => ({
              ...subfornecedor,
              flChecked: true
            }))
          )
          setEmpresaSubContratadaIds(
            subFornecedoresList?.map((subfornecedor) => subfornecedor.id)
          )
          setIgnoreGridName('subFornecedores')
          refreshGrid()
        }
      },
      remove: {
        centro: () =>
          setCentroPlantaIds((prevState) =>
            prevState.filter((itemID) => itemID !== id)
          ),
        contrato: () =>
          setContratoIds((prevState) =>
            prevState.filter((itemID) => itemID !== id)
          ),
        empresa: () =>
          setEmpresaIds((prevState) =>
            prevState.filter((itemID) => itemID !== id)
          ),
        fornecedor: () =>
          setFornecedorIds((prevState) =>
            prevState.filter((itemID) => itemID !== id)
          ),
        subFornecedores: () =>
          setEmpresaSubContratadaIds((prevState) =>
            prevState.filter((itemID) => itemID !== id)
          )
      },
      unCheckAll: {
        centro: () => {
          setCentroList((prevState) =>
            prevState.map((centro) => ({ ...centro, flChecked: false }))
          )
          setCentroPlantaIds([])
          setIgnoreGridName(null)
          refreshGrid()
        },
        contrato: () => {
          setContratoList((prevState) =>
            prevState.map((contrato) => ({ ...contrato, flChecked: false }))
          )
          setContratoIds([])
          setIgnoreGridName(null)
          refreshGrid()
        },
        empresa: () => {
          setEmpresaList((prevState) =>
            prevState.map((empresa) => ({ ...empresa, flChecked: false }))
          )
          setEmpresaIds([])
          setIgnoreGridName(null)
          refreshGrid()
        },
        fornecedor: () => {
          setFornecedorList((prevState) =>
            prevState.map((fornecedor) => ({ ...fornecedor, flChecked: false }))
          )
          setFornecedorIds([])
          setIgnoreGridName(null)
          refreshGrid()
        },
        subFornecedores: () => {
          setSubFornecedoresList((prevState) =>
            prevState.map((subfornecedor) => ({
              ...subfornecedor,
              flChecked: false
            }))
          )
          setEmpresaSubContratadaIds([])
          setIgnoreGridName(null)
          refreshGrid()
        }
      }
    }[actionType][grid]();
  };




  const handleChangeItem = (
    checked: boolean,
    grid: 'contrato' | 'fornecedor' | 'empresa' | 'centro' | 'subFornecedores',
    id: number
  ): void => {
    const actionType = checked ? 'add' : 'remove'
    let notUpdateLastGridInteraction = false
    if (
      grid === 'contrato' &&
      contratoIds.length === 1 &&
      contratoIds.includes(id) &&
      !checked
    )
      notUpdateLastGridInteraction = true
    if (
      grid === 'fornecedor' &&
      fornecedorIds.length === 1 &&
      fornecedorIds.includes(id) &&
      !checked
    )
      notUpdateLastGridInteraction = true
    if (
      grid === 'empresa' &&
      empresaIds.length === 1 &&
      empresaIds.includes(id) &&
      !checked
    )
      notUpdateLastGridInteraction = true
    if (
      grid === 'centro' &&
      centroPlantaIds.length === 1 &&
      centroPlantaIds.includes(id) &&
      !checked
    )
      notUpdateLastGridInteraction = true
    if (
      grid === 'subFornecedores' &&
      empresaSubContratadaIds.length === 1 &&
      empresaSubContratadaIds.includes(id) &&
      !checked
    )
      notUpdateLastGridInteraction = true

    if (notUpdateLastGridInteraction) {
      setIgnoreGridName(null)
    } else {
      setIgnoreGridName(grid)
    }

    setCheckLists((prevCheckLists) => {
      const updatedCheckLists = { ...prevCheckLists };
      if (Array.isArray(updatedCheckLists[grid])) {
        updatedCheckLists[grid] = updatedCheckLists[grid].map((item) =>
          item.id === id ? { ...item, checked: checked } : item
        );
      }
      return updatedCheckLists;
    });

    ActionCheckbox(actionType, grid, id)
    refreshGrid()

    //atualizando o estado do checkSelecionado
    handleCheckSelecionado(checked)
  }

  const fillCardsExcept = (
    cardsData: IFillCardsResponse,
    doNotFillCard: string
  ): void => {
    clearIdsLists(cardsData)
    if (doNotFillCard !== 'contrato') setContratoList(cardsData.contratos)
    if (doNotFillCard !== 'fornecedor')
      setFornecedorList(cardsData.fornecedores)
    if (doNotFillCard !== 'empresa') setEmpresaList(cardsData.empresas)
    if (doNotFillCard !== 'centro') setCentroList(cardsData.centroPlantas)
    if (doNotFillCard !== 'subFornecedores') setSubFornecedoresList(cardsData.subFornecedores)

    if (doNotFillCard === 'contrato') {
      const checkedIds = cardsData.contratos.map(
        (contrato) => contrato.flChecked && contrato.id
      )

      setContratoList((prevState) =>
        prevState.map((contrato) => ({
          ...contrato,
          flChecked: checkedIds.includes(contrato.id)
        }))
      )
    }
    if (doNotFillCard === 'fornecedor') {
      const checkedIds = cardsData.fornecedores.map(
        (fornecedor) => fornecedor.flChecked && fornecedor.id
      )

      setFornecedorList((prevState) =>
        prevState.map((fornecedor) => ({
          ...fornecedor,
          flChecked: checkedIds.includes(fornecedor.id)
        }))
      )
    }
    if (doNotFillCard === 'empresa') {
      const checkedIds = cardsData.empresas.map(
        (empresa) => empresa.flChecked && empresa.id
      )

      setEmpresaList((prevState) =>
        prevState.map((empresa) => ({
          ...empresa,
          flChecked: checkedIds.includes(empresa.id)
        }))
      )
    }
    if (doNotFillCard === 'centro') {
      const checkedIds = cardsData.centroPlantas.map(
        (centro) => centro.flChecked && centro.id
      )

      setCentroList((prevState) =>
        prevState.map((centro) => ({
          ...centro,
          flChecked: checkedIds.includes(centro.id)
        }))
      )
    }
    if (doNotFillCard === 'subFornecedores') {
      const checkedIds = cardsData.subFornecedores.map(
        (subfornecedor) => subfornecedor.flChecked && subfornecedor.id
      )

      setSubFornecedoresList((prevState) =>
        prevState.map((subfornecedor) => ({
          ...subfornecedor,
          flChecked: checkedIds.includes(subfornecedor.id)
        }))
      )
    }
  }

  const removeOldIds = (
    newIdsList: number[],
    grid: 'contrato' | 'fornecedor' | 'empresa' | 'centro' | 'subFornecedores'
  ): void => {
    if (grid === 'contrato')
      setContratoIds((prevState) =>
        prevState.filter((id) => newIdsList.includes(id))
      )
    if (grid === 'fornecedor')
      setFornecedorIds((prevState) =>
        prevState.filter((id) => newIdsList.includes(id))
      )
    if (grid === 'empresa')
      setEmpresaIds((prevState) =>
        prevState.filter((id) => newIdsList.includes(id))
      )
    if (grid === 'centro')
      setCentroPlantaIds((prevState) =>
        prevState.filter((id) => newIdsList.includes(id))
      )
    if (grid === 'subFornecedores')
      setEmpresaSubContratadaIds((prevState) =>
        prevState.filter((id) => newIdsList.includes(id))
      )
  }

  const clearIdsLists = (cardsData: IFillCardsResponse): void => {
    const contratosNewIds = cardsData.contratos?.map((item) => item.id)
    const fornecedoresNewIds = cardsData.fornecedores?.map((item) => item.id)
    const empresasNewIds = cardsData.empresas?.map((item) => item.id)
    const centrosNewIds = cardsData.centroPlantas?.map((item) => item.id)
    const subFornecedoresNewIds = cardsData.subFornecedores?.map(
      (item) => item.id
    )

    removeOldIds(contratosNewIds, 'contrato')
    removeOldIds(fornecedoresNewIds, 'fornecedor')
    removeOldIds(empresasNewIds, 'empresa')
    removeOldIds(centrosNewIds, 'centro')
    removeOldIds(subFornecedoresNewIds, 'subFornecedores')
  }

  const fillCards = (cardsData: IFillCardsResponse): void => {
    clearIdsLists(cardsData)

    setContratoList(cardsData.contratos)
    setFornecedorList(cardsData.fornecedores)
    setEmpresaList(cardsData.empresas)
    setCentroList(cardsData.centroPlantas)
    setSubFornecedoresList(cardsData.subFornecedores)
  }

  // Get FillCards
  const getFillCards = async () => {
    setLoading('loading')
    try {
      const response = await ReportsBlockServices().getFillCards({
        ...(fornecedorIds.length > 0 && { fornecedorIds }),
        ...(contratoIds.length > 0 && { contratoIds }),
        ...(empresaIds.length > 0 && { empresaIds }),
        ...(empresaSubContratadaIds.length > 0 && { empresaSubContratadaIds }),
        ...(centroPlantaIds.length > 0 && { centroPlantaIds }),
        ...(moment(periodoValidadeIni).isValid() &&
          moment(periodoValidadeFim).isValid() && {
          periodoBloqueioInicio: moment(periodoValidadeIni)
            .format('YYYY-MM-DDT00:00:00')
            .toString(),
          periodoBloqueioFim: moment(periodoValidadeFim)
            .format('YYYY-MM-DDT00:00:00')
            .toString()
        }),
        analistaId: analistaId,
        cdCentroPlanta: centro,
        cdContrato: contrato,
        motivoBloqueioId: motivoBloqueioId,
        nomeEmpresa: nomeEmpresa,
        nomeFornecedor: fornecedor,
        ...(txDocumento?.length > 0 && { txDocumento: txDocumento }),
        ...(cdFolhaRegistroSRV?.length > 0 && { cdFolhaRegistroSRV: cdFolhaRegistroSRV }),
        ...(txReferencia?.length > 0 && { txReferencia: txReferencia }),
        nomeSubcontratada: subcontratada,
        tipo: tipoRelatorio,
        tipoSolicitacao: tipoAcao,
        unidadeGestoraId: unidadeGestoraID,
        checkedAll: isCheckedAllFornecedor
      })

      if (response.status !== 200) throw new Error('Erro obter dados.')

      if (ignoreGridName) {
        fillCardsExcept(response.data.entity, ignoreGridName)
      } else {
        fillCards(response.data.entity)
      }

      setLoading('idle')
      handleMotivosBloqueioFiltrado(response.data.entity.motivoBloqueioList);
    } catch (error: any) {
      setLoading('idle')
      showModal({
        hideButtonCancel: true,
        message: 'Erro ao pesquisar dados para consulta!',
        txtButtonConfirm: 'OK',
        type: 'error'
      })
    }
  }

  // AutoComplete
  const handleSearchMatriculaAutoComplete = (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    setLoading('loading')
    UserCsnService()
      .autoComplete({ cdMatricula: event.target.value, nmUsuario: '' })
      .then((response) => {
        setMatriculasList(
          response.data.entity.map((analista) => ({
            label: analista.cdMatricula,
            value: analista.idUsuarioCsn
          }))
        )
        setAnalistasList(
          response.data.entity.map((analista) => ({
            label: analista.nmUsuario,
            value: analista.idUsuarioCsn
          }))
        )
        setLoading('idle')
      })
      .catch(() => {
        setLoading('idle')
      })
  }

  const handleSearchAnalistaAutoComplete = (event) => {
    setLoading('loading')
    UserCsnService()
      .autoComplete({ cdMatricula: '', nmUsuario: event.target.value })
      .then((response) => {
        setAnalistasList(
          response.data.entity.map((analista) => ({
            label: analista.nmUsuario,
            value: analista.idUsuarioCsn
          }))
        )
        setMatriculasList(
          response.data.entity.map((analista) => ({
            label: analista.cdMatricula,
            value: analista.idUsuarioCsn
          }))
        )
        setLoading('idle')
      })
      .catch(() => {
        setLoading('idle')
      })
  }

  const handleSelectedMatricula = (codMatricula: string, idMatricula) => {
    if (idMatricula === 0) {
      setSelectedMatricula('')
      setSelectedAnalista('')
      setAnalistaId(undefined)
      refreshGrid()
      return
    }

    setSelectedMatricula(codMatricula)
    setAnalistaId(idMatricula)

    const analista = analistasList.find(
      (analista) => analista.value == idMatricula
    )

    if (analista) {
      setSelectedAnalista(analista.label)
    }

    refreshGrid()
  }

  const handleSelectedAnalista = (nmAnalista: string, idAnalista: number) => {
    if (idAnalista === 0) {
      setSelectedMatricula('')
      setSelectedAnalista('')
      setAnalistaId(undefined)
      refreshGrid()
      return
    }

    setSelectedAnalista(nmAnalista)
    setAnalistaId(idAnalista)

    const matricula = matriculasList.find(
      (matricula) => matricula.value == idAnalista
    )

    if (matricula) {
      setSelectedMatricula(matricula.label)
    }

    refreshGrid()
  }

  const handleSetUnidadeGestoraID = (e) => {
    setUnidadeGestoraID(e)
    refreshGrid()
  }

  const handleChangeMotivosBloqueio = (value) => {
    if (!value || Number.isNaN(value)) {
      setMotivoBloqueioId(0);
    } else {
      setMotivoBloqueioId(value)
    }
  }
  const persistItensInStorage = () => {
    const blockItensModel: IReportsBlock = {
      centro: centro,
      contrato: contrato,
      fornecedor: fornecedor,
      nomeEmpresa: nomeEmpresa,
      subcontratada: subcontratada,
      analistaId: analistaId,
      motivo: motivoBloqueioId,
      cdFolhaRegistroSRV: cdFolhaRegistroSRV,
      txDocumento: txDocumento,
      txReferencia: txReferencia,
      centros: centroList.map((centro) => ({
        checked: centro.flChecked || false,
        key: centro.id,
        value: centro.name
      })),
      contratos: contratoList.map((contrato) => ({
        checked: contrato.flChecked || false,
        key: contrato.id,
        value: contrato.name
      })),
      empresas: empresaList.map((empresa) => ({
        checked: empresa.flChecked || false,
        key: empresa.id,
        value: empresa.name
      })),
      fimBloqueio: moment(periodoValidadeFim)?.toDate(),
      inicioBloqueio: moment(periodoValidadeIni)?.toDate(),
      fornecedores: fornecedorList.map((fornecedor) => ({
        checked: fornecedor.flChecked || false,
        key: fornecedor.id,
        value: fornecedor.name,
        cdDocto: fornecedor.cdDocto
      })),
      id: 1,
      matricula: selectedMatricula,
      nmAnalista: selectedAnalista,
      subfornecedores: subFornecedoresList.map((subContratada) => ({
        checked: subContratada.flChecked || false,
        key: subContratada.id,
        value: subContratada.name
      })),
      tipoBloqueio: tipoRelatorio,
      unidadeGestoraId: unidadeGestoraID,
      motivoBloqueioList: listMotivosBloqueioFiltrado,
    }

    reportsDatabase.block
      .where({ id: 1 })
      .first()
      .then((existsReport) => {
        if (existsReport) {
          reportsDatabase.block.update(1, blockItensModel)
        } else {
          reportsDatabase.block.add(blockItensModel)
        }
      })
  }

  const resetPage = async () => {
    await reportsDatabase.block
      .delete(1)
      .then(() => {
        unidadeGestoraRef?.current?.clearForm()
      })
      .finally(() => setLoading('idle'))
    push({ pathname: '/ngt/relatorios-bloqueio' })
  }

  const handleVisualizar = (action: string | null = null) => {
    if (
      'relatorio_completo' != action &&
      !checkSelecionado &&
      !checkValuesInput
    ) {
      showModal({
        message:
          'Nenhum dado foi selecionado. Deseja visualizar o relatório completo?',
        txtButtonConfirm: 'SIM',
        txtButtonCancel: 'NÃO',
        handleConfirm() {
          handleVisualizar('relatorio_completo')
        },
        type: 'alert',
        hideButtonCancel: false
      })
      return
    }
    persistItensInStorage()
    if (tipoRelatorio === 2) {
      push({
        pathname: '/ngt/relatorio-fornecedor-bloqueado',
        state: {
          resquestVisualizar: {
            centroPlantaIds:
              centroPlantaIds.length > 0 ? centroPlantaIds : null,
            contratoIds: contratoIds.length > 0 ? contratoIds : null,
            empresaIds: empresaIds.length > 0 ? empresaIds : null,
            empresaSubContratadaIds:
              empresaSubContratadaIds.length > 0
                ? empresaSubContratadaIds
                : null,
            fornecedorIds: fornecedorIds.length > 0 ? fornecedorIds : null,
            motivoBloqueioId,
            tipo: tipoRelatorio,
            periodoBloqueioInicio: moment(periodoValidadeIni)?.toDate(),
            periodoBloqueioFim: moment(periodoValidadeFim)?.toDate(),
            tipoSolicitacao: tipoAcao,
            unidadeGestoraId: unidadeGestoraID,
            usuarioAnalistaId: analistaId,
            txDocumento: txDocumento && txDocumento.length > 0 ? txDocumento : null,
            cdFolhaRegistroSRV: cdFolhaRegistroSRV && cdFolhaRegistroSRV.length > 0 ? cdFolhaRegistroSRV : null,
            txReferencia: txReferencia && txReferencia.length > 0 ? txReferencia : null,
            checkedAll: isCheckedAllFornecedor,
            checkSelecionado: checkSelecionado
          }
        }
      })
      return
    }

    if ([0, 1].includes(tipoRelatorio)) {
      push({
        pathname: '/ngt/relatorio-fr-bloqueada',
        state: {
          resquestVisualizar: {
            centroPlantaIds:
              centroPlantaIds.length > 0 ? centroPlantaIds : null,
            contratoIds: contratoIds.length > 0 ? contratoIds : null,
            empresaIds: empresaIds.length > 0 ? empresaIds : null,
            empresaSubContratadaIds:
              empresaSubContratadaIds.length > 0
                ? empresaSubContratadaIds
                : null,
            fornecedorIds: fornecedorIds.length > 0 ? fornecedorIds : null,
            motivoBloqueioId,
            tipo: tipoRelatorio,
            periodoBloqueioInicio: moment(periodoValidadeIni)?.toDate(),
            periodoBloqueioFim: moment(periodoValidadeFim)?.toDate(),
            tipoSolicitacao: tipoAcao,
            unidadeGestoraId: unidadeGestoraID,
            usuarioAnalistaId: analistaId,
            txDocumento: txDocumento && txDocumento.length > 0 ? txDocumento : null,
            cdFolhaRegistroSRV: cdFolhaRegistroSRV && cdFolhaRegistroSRV.length > 0 ? cdFolhaRegistroSRV : null,
            txReferencia: txReferencia && txReferencia.length > 0 ? txReferencia : null,
            checkedAll: isCheckedAllFornecedor,
            checkSelecionado: checkSelecionado
          }
        }
      })
      return
    }

    if (tipoRelatorio === 3) {
      push({
        pathname: '/ngt/relatorio-fr-liberada',
        state: {
          resquestVisualizar: {
            centroPlantaIds:
              centroPlantaIds.length > 0 ? centroPlantaIds : null,
            contratoIds: contratoIds.length > 0 ? contratoIds : null,
            empresaIds: empresaIds.length > 0 ? empresaIds : null,
            empresaSubContratadaIds:
              empresaSubContratadaIds.length > 0
                ? empresaSubContratadaIds
                : null,
            fornecedorIds: fornecedorIds.length > 0 ? fornecedorIds : null,
            motivoBloqueioId,
            tipo: tipoRelatorio,
            periodoBloqueioInicio: moment(periodoValidadeIni)?.toDate(),
            periodoBloqueioFim: moment(periodoValidadeFim)?.toDate(),
            tipoSolicitacao: tipoAcao,
            unidadeGestoraId: unidadeGestoraID,
            usuarioAnalistaId: analistaId,
            txDocumento: txDocumento && txDocumento.length > 0 ? txDocumento : null,
            cdFolhaRegistroSRV: cdFolhaRegistroSRV && cdFolhaRegistroSRV.length > 0 ? cdFolhaRegistroSRV : null,
            txReferencia: txReferencia && txReferencia.length > 0 ? txReferencia : null,
            checkedAll: isCheckedAllFornecedor,
            checkSelecionado: checkSelecionado
          }
        }
      })
      return
    }
    if (tipoRelatorio == 4) {
      push({
        pathname: '/ngt/relatorio-todos-fornecedores',
        state: {
          requestVisualizar: {
            centroPlantaIds: centroPlantaIds.length > 0 ? centroPlantaIds : null,
            fornecedorIds: fornecedorIds.length > 0 ? fornecedorIds : null,
            motivoBloqueioId,
            tipo: tipoRelatorio,
            periodoBloqueioInicio: moment(periodoValidadeIni)?.toDate(),
            periodoBloqueioFim: moment(periodoValidadeFim)?.toDate(),
            tipoSolicitacao: tipoAcao,
            unidadeGestoraId: unidadeGestoraID,
            usuarioAnalistaId: analistaId,
            txDocumento: txDocumento && txDocumento.length > 0 ? txDocumento : null,
            cdFolhaRegistroSRV: cdFolhaRegistroSRV && cdFolhaRegistroSRV.length > 0 ? cdFolhaRegistroSRV : null,
            txReferencia: txReferencia && txReferencia.length > 0 ? txReferencia : null,
            checkedAll: isCheckedAllFornecedor,
            checkSelecionado: checkSelecionado
          }
        }
      })
    }
    return
  }

  useEffect(() => {
    getMotivosBloqueio()
  }, [])

  return (
    <Card
      marginTop={SPACING.spacing20}
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      marginBottom={SPACING.spacing100}
      padding={SPACING.spacing20}
      boxShadow={`0 0 1em ${COLORS.lightGray}`}
    >
      <TypeDate
        tipoRelatorio={tipoRelatorio}
        changeTipo={setTipoRelatorio}
        isCompetencia
        setDataFim={setPeriodoValidadeFim}
        setDataIni={setPeriodoValidadeIni}
        dataIni={
          moment(periodoValidadeIni).isValid()
            ? moment(periodoValidadeIni).toDate()
            : null
        }
        dataFim={
          moment(periodoValidadeFim).isValid()
            ? moment(periodoValidadeFim).toDate()
            : null
        }
      />
      <CardFiltersGrid
        centros={centroList}
        fornecedores={fornecedorList}
        subcontratada={subcontratada}
        centro={centro}
        empresas={empresaList}
        empresa={nomeEmpresa}
        fornecedor={fornecedor}
        contratos={contratoList}
        contrato={contrato}
        handleChangeInput={handleChangeInput}
        getData={getFillCards}
        subFornecedores={subFornecedoresList}
        handleChangeItem={handleChangeItem}
        checkAll={ActionCheckbox}
        isCheckAll={isCheckedAllFornecedor}
        isCheckAllFornecedor={isCheckedAllFornecedor}
        setIsCheckAllFornecedor={handleCheckAllChange}
        checkedSelecionado={handleCheckSelecionado}
      />
      <DirectorsManagers
        setUnidadeGestoraID={handleSetUnidadeGestoraID}
        handleSearchMatriculaAutoComplete={handleSearchMatriculaAutoComplete}
        handleSearchAnalistaAutoComplete={handleSearchAnalistaAutoComplete}
        handleSelectedAnalista={handleSelectedAnalista}
        handleSelectedMatricula={handleSelectedMatricula}
        analistas={analistasList}
        matriculas={matriculasList}
        selectedAnalita={selectedAnalista}
        selectedMatricula={selectedMatricula}
        listMotivosBloqueio={listMotivosBloqueioFiltrado}
        handleChangeMotivosBloqueio={handleChangeMotivosBloqueio}
        motivoBloqueioId={motivoBloqueioId}
        tipoAcao={tipoAcao}
        setTipoAcao={setTipoAcao}
        referencia={unidadeGestoraRef}
        getData={getFillCards}
        cdFolhaRegistroSRV={cdFolhaRegistroSRV}
        setCdFolhaRegistroSRV={setCdFolhaRestroSRV}
        txDocumento={txDocumento}
        setTxDocumento={setTxDocumento}
        txReferencia={txReferencia}
        setTxReferencia={setTxReferencia}
      />
      <ButtonsRow
        resetPage={resetPage}
        handleVisualizar={handleVisualizar}
        disableImprimir={true}
      />
    </Card>
  )
}

export default ReportsBlock
